import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "@mui/material";
import Page from "../../layout/Page";
import { DataTable } from "../../components/DataTable";
import ListPageActions from "../../components/ListPageActions";
import DownloadButton from "../../components/DownloadButton";
import SwitchCell from "../../components/SwitchCell";
import CustButton from "../../ui/CustButton";
import { YesNoTypeOptions } from "../../components/YesNoTypeOptions";
import DialogConfirm from "../../components/DialogConfirm";
import usePaginationV2 from "../../util/usePaginationV2";

import MenuListAction from "../../components/MenuListAction";
import { Add, Edit, Delete, Settings, WrapText } from "@mui/icons-material";
import masterTenantservice from "../../service/MasterServices/MasterTenantService";
import MasterTenantCrudDialog from "./MasterTenantCrudDialog";
import AuthenticationType from "../../enum/AuthenticationType";
import TruncatedText from "../../components/TruncatedText";
import MasterTenantModulDialog from "./MasterTenantModulDialog";
import FilterOptionEnum from "../../enum/FilterOptionEnum";
import ColList from "../../components/tableComponent/ColList";
import PopoverList from "../../components/tableComponent/PopoverList";
import TenantBatchOperationDialog from "./TenantBatchOperationDialog";
import DynamicOptions from "../../components/DynamicOptions";
import ModulTipi from "../../enum/ModulTipi";

const MasterTenantPage = ({ title }) => {

    const { t } = useTranslation();
    const [selectedItems, setSelectedItems] = useState([]);
    const [deleteItem, setDeleteItem] = useState(null);
    const [actionType, setActionType] = useState(null);
    const [loading, setLoading] = useState(false); // Loading state for action handling
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedKey, setselectedKey] = useState(null);
    const [isDetayDialogOpen, setDetayDialogOpen] = useState(false);
    const [isTruncated, setIsTruncated] = useState(true);
    const [crudTip, setCrudTip] = useState("");

    // Switch change handler
    const handelaktifSwitchChange = async (item, newCheckedVal) => {
        console.log(item, newCheckedVal);
        let result = await masterTenantservice.update({
            id: item.id,
            aktif: !item.aktif
        });
        mainDataList.search();
        return true;
    };

    // Toggle between truncated and full text
    const handleToggle = () => {
        setIsTruncated(prevState => !prevState);
    };

    // Handle delete actions
    const handleDeleteAction = async () => {
        if (!deleteItem) return;

        setLoading(true);  // Start loading
        try {
            const result = await masterTenantservice.delete(deleteItem.id);

            if (result) {
                mainDataList.search();  // Refresh data after success
            }
        } catch (error) {
            console.error("Action failed:", error); // Handle any error that occurs during the action
            // Optionally, display an error notification or message
        } finally {
            setLoading(false);  // End loading regardless of success or failure
            setOpenDialog(false);  // Close the confirm dialog
        }
    };

    // Handle detay dialog open/close
    const openDetayDialog = (id) => {
        setselectedKey(id);
        setDetayDialogOpen(true);
    };
    const closeDetayDialog = async () => {
        setselectedKey(null);
        setDetayDialogOpen(false);
        await mainDataList.search([]);
    };



    const [isTenantBatchOperationOpen, setTenantBatchOperationOpen] = useState(false);

    const [TenantBatchOperationKey, setTenantBatchOperationKey] = useState(null);


    // Handle detay dialog open/close
    const openTenantBatchOperationDialog = (id) => {
        setTenantBatchOperationKey(id);
        setTenantBatchOperationOpen(true);
    };
    const closeTenantBatchOperationDialog = () => {
        setTenantBatchOperationKey(null);
        setTenantBatchOperationOpen(false);
        mainDataList.search();
    };


    // Column definitions
    const columns = [
        {
            passItem: true,
            searchable: false,
            sortable: false,
            label: t('label.islemler'),
            execute: (item) => <MenuListAction menuItems={
                [
                    {
                        label: t('label.moduller'),
                        icon: <Settings fontSize="small" style={{ color: '#DDD4FF' }} />,
                        action: () => {
                            openDetayDialog(item.id);
                        }
                    },
                    /*    {
                            label: t('label.batchOperation'),
                            icon: <Settings fontSize="small" style={{ color: '#DDD4FF' }} />,
                            action: () => {
                                openTenantBatchOperationDialog(item.id);
                            }
                        },*/
                ]
            } />
        },
        {
            name: "name",
            label: t('label.name'),
            textAlign: "left"
        },
        {
            name: "connectionString",
            label: t('label.connectionString'),
            textAlign: "left",
            execute: (item =>
                <TruncatedText
                    text={`${item ?? ""}`}
                    maxLength={25}
                    truncated={isTruncated}

                />
            )
        },
        {
            name: "systemAuthenticationType",
            label: t('label.systemAuthenticationType'),
            textAlign: "left",
            execute: (item) => AuthenticationType[item],
            searchable: true,
            searchType: "select",
            selectOptions: <FilterOptionEnum enumObject={AuthenticationType} />
        },
        {
            name: "ldapHost",
            label: t('label.ldapHost'),
            textAlign: "left"
        },
        {
            name: "ldapDirectory",
            label: t('label.ldapDirectory'),
            textAlign: "left"
        },
        {
            name: "startPage",
            label: t('label.startPage'),
            textAlign: "left"
        },
        {
            name: "uiStartPage",
            label: t('label.uiStartPage'),
            textAlign: "left"
        },
        {
            passItem: true,
            sortable: false,
            searchField: "modelTipi",
            label: t('label.moduller'),
            textAlign: "center",
            execute: (item) => {
                return (isTruncated ?
                    <PopoverList label={t("label.moduller")} items={item.masterTenantModul} displayField="modulTipiDesc" />
                    :
                    <ColList items={item.masterTenantModul} displayField="modulTipiDesc" />
                )
            },
            searchType: "select",
            selectOptions: <FilterOptionEnum enumObject={ModulTipi} />
        },
        {
            passItem: true,
            sortable: false,
            searchField: "operationId",
            label: t('label.batchOperation'),
            selectOptions: <DynamicOptions serviceType="BatchOperation" />,
            textAlign: "center",
            searchType: 'select',
            execute: (item) => {
                return (isTruncated ?
                    <PopoverList label={t("label.batchOperation")} items={item.tenantBatchOperation} displayField="operationName" />
                    :
                    <ColList items={item.tenantBatchOperation} displayField="operationName" />
                )
            }
        },
        {
            name: "aktif",
            type: Boolean,
            label: t('label.aktif'),
            textAlign: "center",
            passItem: true,
            searchable: true,
            searchType: "select",
            selectOptions: <YesNoTypeOptions />,
            execute: (item) =>
            (<SwitchCell item={item}
                checked={item.aktif}
                onClick={(newCheckedVal) => handelaktifSwitchChange(item, newCheckedVal)}
            />)
        },
        {
            sortable: false,
            searchable: false,
            passItem: true,
            textAlign: "Center",
            title: "action",
            execute: (item) => (
                <>
                    <IconButton
                        onClick={() => handleOpenCrudDialog(item, "Update")}
                        color="warning"
                        variant="contained"
                        title={t("rowActions.update")}
                        size="small">
                        <Edit />
                    </IconButton>
                    <IconButton
                        onClick={() => openConfirmDialog(item)}
                        color="error"
                        variant="contained"
                        title={t("rowActions.delete")}
                        size="small">
                        <Delete />
                    </IconButton>
                </>
            ),
        },

    ];

    // Pagination configuration
    const mainDataList = usePaginationV2({
        service: masterTenantservice,
        pageColumns: columns,
        defaultOrderBy: [{ key: "Id", value: "Desc" }],
    });

    // Handle Crud dialog open/close
    ///**********************/////


    const [crudItem, setCrudItem] = useState(null);
    const [onCrudDialogOpen, setCrudDialogOpen] = useState(false);

    const handleOpenCrudDialog = (data, tip) => {
        setCrudItem(data);  // Set the data to pass to the dialog
        setCrudDialogOpen(true);
        setCrudTip(tip);
    };

    const handleMasterTenantClose = async () => {
        setCrudDialogOpen(false);
        await mainDataList.search([]); // Clear the dialog data when closing
    };

    // Handle confirm dialog open/close
    const openConfirmDialog = (item) => {
        // setActionType(item);
        setDeleteItem(item);
        setOpenDialog(true);
    };



    const closeConfirmDialog = async () => {
        setOpenDialog(false);
        await mainDataList.search([]);
    }

    // Action buttons component
    const ActionButtons = () => (
        <ListPageActions
            left={
                <>
                    <CustButton
                        icon={Add}
                        onClick={() => handleOpenCrudDialog(null, "Create")}
                        style={{ marginLeft: 10 }}
                        disabled={loading}  // Disable buttons when loading
                    >
                        {t(title) + " " + t('button.add')}
                    </CustButton>
                </>
            }
            right={
                <>
                    <CustButton
                        icon={WrapText}
                        onClick={() => handleToggle()}
                        style={{ marginLeft: 10 }}
                        disabled={loading}  // Disable buttons when loading
                    ></CustButton>
                </>
            }
        >
            <DownloadButton service={mainDataList} disabled={loading} />
        </ListPageActions>
    );

    return (
        <Page title={t(title)}>
            <ActionButtons />

            <DataTable
                columns={columns}
                {...mainDataList}
                loading={loading}  // Pass loading state to DataTable if applicable
            />


            < MasterTenantCrudDialog
                open={onCrudDialogOpen}
                onClose={() => handleMasterTenantClose()}
                data={crudItem}
                crudTip={crudTip}
                title={t('label.tenant')}

            />

            <MasterTenantModulDialog
                open={isDetayDialogOpen}
                onClose={closeDetayDialog}
                selectedKey={selectedKey}
            />

            <TenantBatchOperationDialog
                open={isTenantBatchOperationOpen}
                onClose={closeTenantBatchOperationDialog}
                selectedKey={TenantBatchOperationKey}
            />

            <DialogConfirm
                open={openDialog}
                title={t('title.confirmDialogTitle')}
                content={t('message.areYouSureAction')}
                onClose={closeConfirmDialog}
                //onConfirm={handleAction}
                onConfirm={handleDeleteAction}
                loading={loading}  // Disable confirm button when loading
            />
        </Page>
    );
};

export default MasterTenantPage;
